'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _scales = require('../foundational-styles/scales');

var _scales2 = _interopRequireDefault(_scales);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Get the themed properties for a `Code` text component.
 * @param {string} appearance - default, minimal.
 * @return {string} the themd properties.
 */
var getCodeProps = function getCodeProps(appearance) {
  switch (appearance) {
    case 'minimal':
      return {};
    case 'default':
    default:
      // Passing padding and border radius is non-ideal here.
      return {
        backgroundColor: _scales2.default.primary.P2A,
        boxShadow: 'inset 0 0 0 1px ' + _scales2.default.primary.P4A,
        paddingLeft: 6,
        paddingRight: 6,
        paddingTop: 3,
        paddingBottom: 3,
        borderRadius: 2
      };
  }
};

exports.default = getCodeProps;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy90aGVtZS9zcmMvZGVmYXVsdC10aGVtZS9jb21wb25lbnQtc3BlY2lmaWMvZ2V0Q29kZVByb3BzLmpzIl0sIm5hbWVzIjpbImdldENvZGVQcm9wcyIsImFwcGVhcmFuY2UiLCJiYWNrZ3JvdW5kQ29sb3IiLCJzY2FsZXMiLCJwcmltYXJ5IiwiUDJBIiwiYm94U2hhZG93IiwiUDRBIiwicGFkZGluZ0xlZnQiLCJwYWRkaW5nUmlnaHQiLCJwYWRkaW5nVG9wIiwicGFkZGluZ0JvdHRvbSIsImJvcmRlclJhZGl1cyJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUE7Ozs7OztBQUVBOzs7OztBQUtBLElBQU1BLGVBQWUsU0FBZkEsWUFBZSxhQUFjO0FBQ2pDLFVBQVFDLFVBQVI7QUFDRSxTQUFLLFNBQUw7QUFDRSxhQUFPLEVBQVA7QUFDRixTQUFLLFNBQUw7QUFDQTtBQUNFO0FBQ0EsYUFBTztBQUNMQyx5QkFBaUJDLGlCQUFPQyxPQUFQLENBQWVDLEdBRDNCO0FBRUxDLHdDQUE4QkgsaUJBQU9DLE9BQVAsQ0FBZUcsR0FGeEM7QUFHTEMscUJBQWEsQ0FIUjtBQUlMQyxzQkFBYyxDQUpUO0FBS0xDLG9CQUFZLENBTFA7QUFNTEMsdUJBQWUsQ0FOVjtBQU9MQyxzQkFBYztBQVBULE9BQVA7QUFOSjtBQWdCRCxDQWpCRDs7a0JBbUJlWixZIiwiZmlsZSI6ImdldENvZGVQcm9wcy5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzY2FsZXMgZnJvbSAnLi4vZm91bmRhdGlvbmFsLXN0eWxlcy9zY2FsZXMnXG5cbi8qKlxuICogR2V0IHRoZSB0aGVtZWQgcHJvcGVydGllcyBmb3IgYSBgQ29kZWAgdGV4dCBjb21wb25lbnQuXG4gKiBAcGFyYW0ge3N0cmluZ30gYXBwZWFyYW5jZSAtIGRlZmF1bHQsIG1pbmltYWwuXG4gKiBAcmV0dXJuIHtzdHJpbmd9IHRoZSB0aGVtZCBwcm9wZXJ0aWVzLlxuICovXG5jb25zdCBnZXRDb2RlUHJvcHMgPSBhcHBlYXJhbmNlID0+IHtcbiAgc3dpdGNoIChhcHBlYXJhbmNlKSB7XG4gICAgY2FzZSAnbWluaW1hbCc6XG4gICAgICByZXR1cm4ge31cbiAgICBjYXNlICdkZWZhdWx0JzpcbiAgICBkZWZhdWx0OlxuICAgICAgLy8gUGFzc2luZyBwYWRkaW5nIGFuZCBib3JkZXIgcmFkaXVzIGlzIG5vbi1pZGVhbCBoZXJlLlxuICAgICAgcmV0dXJuIHtcbiAgICAgICAgYmFja2dyb3VuZENvbG9yOiBzY2FsZXMucHJpbWFyeS5QMkEsXG4gICAgICAgIGJveFNoYWRvdzogYGluc2V0IDAgMCAwIDFweCAke3NjYWxlcy5wcmltYXJ5LlA0QX1gLFxuICAgICAgICBwYWRkaW5nTGVmdDogNixcbiAgICAgICAgcGFkZGluZ1JpZ2h0OiA2LFxuICAgICAgICBwYWRkaW5nVG9wOiAzLFxuICAgICAgICBwYWRkaW5nQm90dG9tOiAzLFxuICAgICAgICBib3JkZXJSYWRpdXM6IDJcbiAgICAgIH1cbiAgfVxufVxuXG5leHBvcnQgZGVmYXVsdCBnZXRDb2RlUHJvcHNcbiJdfQ==